import { ListItemButton, ListItemText } from "@mui/material";
import { Link } from "react-router";
import type { AssistantTaskRunListItem } from "../../../../api/types/assistantTypes";
import RunStatusChip from "../RunStatusChip";
import { formatTaskTime } from "./taskStatus";

interface Props {
  run: AssistantTaskRunListItem;
  to: string;
  divider: boolean;
}

const TaskRunRow = ({ run, to, divider }: Props) => (
  <ListItemButton component={Link} to={to} divider={divider} sx={{ gap: 1 }}>
    <ListItemText primary={formatTaskTime(run.createdAt)} />
    <RunStatusChip status={run.status} height="smaller" />
  </ListItemButton>
);

export default TaskRunRow;
